import AmlCheck from './AmlCheck';

export default AmlCheck;
